// /utils/frontendVersionCheck.js

import buildGitSha from "../src/buildGitSha.js";

const STORAGE_KEY = "frontend:lastVersion";

export function getStoredVersion() {
  return localStorage.getItem(STORAGE_KEY);
}

export function setStoredVersion(version) {
  localStorage.setItem(STORAGE_KEY, version);
}

export function getRunningVersion() {
  const v = buildGitSha;
  return typeof v === "string" && v && v !== "unknown" ? v : null;
}

/** Live deploy manifest written by genVersion.js on the static host */
export async function fetchDeployedVersion() {
  try {
    const res = await fetch(`/version.js?t=${Date.now()}`, {
      cache: "no-store",
      credentials: "same-origin",
    });
    if (!res.ok) return null;
    const text = await res.text();
    const match = text.match(/CURRENT_GIT_VERSION\s*=\s*"([^"]+)"/);
    return match?.[1] || null;
  } catch {
    return null;
  }
}


/** Prefer static deploy manifest; WS/DB may lag if CI notify failed */
export function pickRemoteVersion(deployed, wsOrApi) {
  return deployed || wsOrApi || null;
}
